export default __webpack_public_path__ + "static/media/bright-squares.79000482.png";